import {
    setLocalItem,
    getLocalItem
  } from '@/utils/auth'
  import request from '@/utils/request'
  import api from '@/api'
  
  const getDefaultState = () => {
    return {
      wordbooks: getLocalItem(api.keys.wordbooks)
    }
  }
  
  const state = getDefaultState()
  
  const mutations = {
    SET_WORDBOOK: (state, data) => {
      state.wordbooks = data
    }
  }
  
  const actions = {
    // 获取数据字典
    getWordbooks({ commit }) {
      return new Promise((resolve, reject) => {
        request.get(api.common.wordbooks).then(res => {
          const { data } = res
          commit('SET_WORDBOOK', data)
          setLocalItem(api.keys.wordbooks, data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  